import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import SortSelector from '../../../../ProductListing/molecules/SortSelector/views/SortSelector.view';
import getSortOptions from '../../../../ProductListing/molecules/SortSelector/views/Sort.util';
import { StyledSortSelector, SortTitle, SortContent } from '../styles/SortWrapper.style';
import OneHrFilterContainer from '../../../../OneHrFilter/container/OneHrFilter.container';

const SortWrapper = (props) => {
  const {
    submitSortChange,
    totalProductsCount,
    sortByRatingLabel,
    pathName,
    isOneHrFilterEnabled,
    isPlp,
    isQuickFilters,
    hideOneHrFilter,
    hideSort,
    isPLPSortAndOneHrFilterRedesignEnabled,
  } = props;
  const sortOptions = getSortOptions({ sortByRatingLabel });
  const getSortCustomOptionsMap = useCallback((sortOptionsMap) => {
    return sortOptionsMap.map((sortOption) => ({
      value: sortOption.id,
      title: <SortTitle className="sort-item-selected">{sortOption.displayName}</SortTitle>,
      content: <SortContent className="sort-title">{sortOption.displayName}</SortContent>,
    }));
  });

  return (
    <StyledSortSelector
      totalProductsCount={totalProductsCount}
      isOneHrFilterEnabled={isOneHrFilterEnabled}
      className="one-hr-filter-and-sort-selector-wrapper"
      isQuickFilters={isQuickFilters}
    >
      {!hideOneHrFilter && (
        <OneHrFilterContainer
          pathName={pathName}
          isPlp={isPlp}
          isPLPSortAndOneHrFilterRedesignEnabled={isPLPSortAndOneHrFilterRedesignEnabled}
        />
      )}
      {!hideSort && (
        <SortSelector
          sortSelectOptions={getSortCustomOptionsMap(sortOptions)}
          onChange={submitSortChange}
          className="sort-dropdown-wrapper"
        />
      )}
    </StyledSortSelector>
  );
};

SortWrapper.propTypes = {
  submitSortChange: PropTypes.func,
};

SortWrapper.defaultProps = {
  submitSortChange: () => {},
};

export default reduxForm({
  form: 'filter-form',
  enableReinitialize: true,
})(SortWrapper);
export { SortWrapper as SortWrapperVanilla };
